import React, { useEffect, useMemo } from 'react';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { handleDetailStreamingFilterParamsToApi } from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import { FilterTimeType } from '@intelligence/utils/filterUtils';
import StreamingContext from './components/StreamingContext';
import type { TopchartFilterCfgType } from '@intelligence/types/topchart';
import {
  getDetailStreamingValidUrlParams,
  detailStreamingValidCfg,
  hasShortLinkRatio,
} from '@intelligence/_config/urlPageValidCfg';
import { useShortLink } from '@intelligence/hooks/useShortLink';
import { URL_SORT_NAME, URL_2_SORT_NAME } from '@intelligence/utils/urlPathCfg';

const ratioObj = {
  mobile: hasShortLinkRatio.detailMobileStreaming,
  pc: hasShortLinkRatio.detailPCStreaming,
  console: hasShortLinkRatio.detailConsoleStreaming,
} as any;

export default function StreamingCom(props: any) {
  const { entityType, activeTab, urlFilterValue } = props;
  // 是否有短链接更新功能
  const hasUrlShortLink = ratioObj?.[entityType] || false;
  const {
    initShortLinkCfgNoAwait,
    shortLinkLoading,
    urlCustomParams,
    shortLinkFilterValue,
    shortLinkValidQuery,
  } = useShortLink({
    urlFilterValue,
    hasUrlShortLink,
    getPageValidCfg: (urlFilter) => {
      const platformValues = urlFilter?.[filterKeyMap.STREAMING_PLATFORM]?.value || [];
      return {
        ...detailStreamingValidCfg,
        // 默认时间排序
        [URL_SORT_NAME]: platformValues?.length
          ? ['date', ...platformValues]
          : ['date', 'twitch', 'ytg', 'facebook'],
        [URL_2_SORT_NAME]: [activeTab],
      };
    },
    getCustomValidUrlParams: getDetailStreamingValidUrlParams,
  });

  useEffect(() => {
    // 进入页面时判断是否有 tokenQuery 等，有则进入
    initShortLinkCfgNoAwait();
  }, []);

  const defaultFilterValue = useMemo(
    () => ({
      [filterKeyMap.RANGE_TIME]: {
        type: 'date',
        value: ['', ''],
      },
      [filterKeyMap.STREAMING_PLATFORM]: {
        value: ['twitch', 'ytg', 'facebook'],
      },
    }),
    [],
  );

  const filterCfg: TopchartFilterCfgType = useMemo(
    () => ({
      filterKeyList: [filterKeyMap.RANGE_TIME, filterKeyMap.STREAMING_PLATFORM],
      regionFilterParams: {},
      defaultValue: defaultFilterValue,
      resetFilterValue: {
        ...defaultFilterValue,
      },
      specialParams: {
        regionOptions: [], // 国家筛选器 options,
        defalutMarket: [], // 没取到交集用的默认值
        rangeTimeType: FilterTimeType.commonRange,
      },
      showConfirmButton: false,
      haveFilterSaveBtn: false,
      handleFilterToApiParams: handleDetailStreamingFilterParamsToApi,
      hasUrlShortLink,
    }),
    [hasUrlShortLink, defaultFilterValue],
  );

  return (
    <StreamingContext
      {...props}
      filterLoading={shortLinkLoading}
      // // 筛选器相关配置如筛选器展示顺序，默认值等
      filterCfg={filterCfg}
      // 从短链接中拿到校正后的url参数（与页面相关）
      channelUrlCustomParams={urlCustomParams?.channel || {}}
      trendUrlCustomParams={urlCustomParams?.trend || {}}
      // 筛选器有效的页面配置值
      shortLinkValidQuery={shortLinkValidQuery}
      // 从短链接拿到的筛选器分享值
      shortLinkFilterValue={shortLinkFilterValue}
    />
  );
}
